import { useMemo } from "react";

import { useGetIvideonEventTypes } from "~/entity/Logs";
import {
  FilterFieldOption,
  FilterFieldOptionsHookResult,
} from "~/features/filter";

/**
 * Опции фильтра «Список логов»: типы событий Ivideon (GET /logs/event-types).
 */
export const useEventTypeOptions = (): FilterFieldOptionsHookResult => {
  const { data, isLoading } = useGetIvideonEventTypes();

  const options = useMemo<FilterFieldOption[]>(
    () =>
      (Array.isArray(data) ? data : []).map((item) => ({
        label: item.eventDescription,
        value: item.eventType,
      })),
    [data],
  );

  return { options, loading: isLoading };
};
